import { forwardRef, type InputHTMLAttributes } from "react";
import MuiTextField, { type TextFieldProps } from "@mui/material/TextField";
import { useForkRef } from "@mui/material/utils";
import { useGoogleAttributes } from "@/lib/translation/useGoogleAttributes";

/** Translate presentation attributes without ever rewriting an input value. */
const GoogleTextField = forwardRef<HTMLDivElement, TextFieldProps>(
  function GoogleTextField(props, forwardedRef) {
    const htmlInput = props.slotProps?.htmlInput;
    const inputProps = (
      typeof htmlInput === "object" ? htmlInput : {}
    ) as InputHTMLAttributes<HTMLInputElement>;
    const input = useGoogleAttributes<HTMLInputElement>({
      placeholder: inputProps.placeholder ?? props.placeholder,
      "aria-label": inputProps["aria-label"],
      title: inputProps.title,
    });
    const root = useGoogleAttributes<HTMLDivElement>({
      "aria-label": props["aria-label"],
      title: props.title,
    });
    const inputRef = useForkRef(props.inputRef, input.ref);
    const rootRef = useForkRef(forwardedRef, root.ref);
    return <MuiTextField {...props} ref={rootRef} inputRef={inputRef} />;
  },
);

export default GoogleTextField as typeof MuiTextField;
